import { render, staticRenderFns } from "./ConfirmCollectionModal.vue?vue&type=template&id=5b8b43fa&scoped=true&"
import script from "./ConfirmCollectionModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmCollectionModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmCollectionModal.vue?vue&type=style&index=0&id=5b8b43fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8b43fa",
  null
  
)

export default component.exports